import React, {Component} from 'react';
import SelectInput from '../../components/Common/SelectInput'
import {getAuthToken} from '../../utils';
import {connect} from 'react-redux';
import './SmartIdCodeSelection.scss';
import {Api} from "../../api";
import ButtonInput from "../../components/Common/ButtonInput";


class SmartIdCodeSelection extends Component {

    state = {
        isLoading: true,
        countries: [],
        countryTitle: null,
        countryId: null,
        confirmDisabled: true,
        personalCode: null,
        verificationCode: null,
    };

    // https://blockchain.info/rawtx/db8c91ad78f6905d562db9ba460c70379e6b47b395728d9b66a822a56088942f
    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate() {
    }

    componentWillMount() {
        this.props.handleLoader(true);
    }

    componentDidMount() {
        const authToken = getAuthToken();
        Api.get(`applet/countries`, authToken)
            .then((response) => {
                let countries = response.data.map((country, index) => ({
                    id: country.id,
                    value: country.id,
                    title: country.country,
                }));

                this.setState({countries, countryTitle: countries[0].title, isLoading: false});
                setTimeout(() => this.props.handleLoader(false), 200)
            }).catch((error) => {
            this.setState({isLoading: false});
            setTimeout(() => this.props.handleLoader(false), 200)
        });
    }

    handleChange = event => {
        const {errors, countries, providers} = this.state;
        console.log(event.target.name, 'event.target.name', event.target.value);

        this.setState({
            [event.target.name]: event.target.value,
        });

        if (event.target.name === 'country') {
            let countryId = null;

            countries.map((country, index) => {
                if (country.title === event.target.value)
                    countryId = country.id;
            });

            this.setState({countryId: countryId});
        }
    };

    enterCode = event => {
        const personalCode = event.target.value;
        if (personalCode.length === 11) {
            this.setState({personalCode: personalCode, confirmDisabled: false})
        } else {
            this.setState({personalCode: personalCode, confirmDisabled: true})
        }
    };

    confirm = event => {
        this.setState({isLoading: true});
        this.props.handleLoader(true);
        const auth = getAuthToken();
        Api.post(`certificates/smart-id?tax_number=${this.state.personalCode}&country_name=${this.state.countryTitle}`,null, auth)
            .then(response => {
                const verificationCode = response.data.result;
                this.interval = setInterval(() => this.getPersonalData(), 1000);
                this.setState({isLoading: false, verificationCode: verificationCode});
                setTimeout(() => this.props.handleLoader(false), 200);
            }).catch(error => {
                 alert(error.response.data);
            this.setState({isLoading: false});
                setTimeout(() => this.props.handleLoader(false), 200);
        });
    };

    getPersonalData = () => {
        const authToken = getAuthToken();
        Api.get(`certificates/current`, authToken)
            .then((response) => {
                if (response.data.length > 0) {
                    const certificates = response.data;
                    console.log(certificates);
                    let allCompaniesConfirmed = true;
                    for (const certificate of certificates) {
                        let hasCompany = false;
                        for (const company of certificate.companies) {
                            if (company) {
                                hasCompany = true;
                            }
                            if (!company.confirmed) {
                                allCompaniesConfirmed = false;
                            }
                        }

                        if (!hasCompany) {
                            this.props.history.push('/user/personal-data/search-for-companies');
                            return;
                        }
                    }
                    if (allCompaniesConfirmed) {
                        this.props.history.push('/user/personal-data/wait-for-payment');
                    } else {
                        this.props.history.push('/user/personal-data/confirm-companies');
                    }
                }
            }).catch((error) => {
            setTimeout(() => this.props.handleLoader(false), 200)
        });
    };

    render() {
        const {countries, countryTitle, isLoading, confirmDisabled, verificationCode} = this.state;

        return (!isLoading ?
                <div className='content-wrapper'>
                    <div className="content">
                        <div className={'smart-id-content-body'}>
                            <div className={'center'}>
                                {!verificationCode ?
                                    <div>
                                        <SelectInput name='country'
                                                     id='country'
                                                     label='Select your country'
                                                     value={countryTitle}
                                                     required={true}
                                                     classes='width-328'
                                                     options={countries}
                                                     handleChange={(e) => this.handleChange(e)}/>
                                        <input type="text" className="form-control width-328" placeholder="Personal code"
                                               onChange={(e) => this.enterCode(e)}/>
                                        <ButtonInput
                                            id="next-button"
                                            className={'dark-button black-btn search-bth next-button'}
                                            title='Confirm'
                                            disabled={confirmDisabled}
                                            handleClick={(e) => this.confirm()}/>
                                    </div> :
                                    <div>
                                        <p className={'verification-label'}>Verification code</p>
                                        <p className={'verification-code'}>{verificationCode}</p>
                                        <div className="loader"></div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div> : <div></div>
        )
    }
}


function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(SmartIdCodeSelection);


// WEBPACK FOOTER //
// ./src/views/SmartIdCodeSelection/SmartIdCodeSelection.js